 



<div id="page-container" class="main-content-boxed">
    <!-- Main Container -->
    <main id="main-container">
        <!-- Page Content -->
        <div class="bg-gd-duskx">

            <div class="hero-static content content-full bg-white invisibles" data-toggle="appears">
                <!-- Header -->
                <div class="py-30 px-5 text-center">

                    <h1 class="h2 font-w700 mt-50 mb-10">Your password has been reset</h1>
                </div>
                <!-- END Header -->
 
 
                <div class="row justify-content-center px-5">

                    <div class="col-sm-8 col-md-6 col-xl-4"> 
  
                        <div class="form-group row gutters-tiny">
                            <div class="col-12 mb-10">
                                <button type="button" [routerLink]="'/login'" class="btn btn-block btn-hero btn-noborder btn-rounded btn-alt-success">
                                    <i class="si si-user-follow mr-10"></i> Continue
                                </button>
                            </div> 
                        </div>

                    </div>
                </div> 
 
            </div>
        </div>
        <!-- END Page Content -->
    </main>
    <!-- END Main Container -->
</div>
<!-- END Page Container -->



